import { Scissors, Flame, Wrench, Boxes, ArrowUpRight } from "lucide-react";

const scrollToBook = () => {
  const el = document.getElementById("book");
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const services = [
  {
    icon: Scissors,
    title: "Laser Cutting",
    blurb:
      "Clean, burr-free cuts on metal, wood, acrylic and more. Send a DXF, STEP, or PDF — we'll handle the rest.",
    bullets: ["Sheet metal & plate", "Acrylic & wood", "Up to 1\" thick steel"],
    img: "https://images.unsplash.com/photo-1738162837451-2041c1418f54?auto=format&fit=crop&w=1600&q=80",
  },
  {
    icon: Flame,
    title: "Laser Engraving",
    blurb:
      "Permanent marks for branding, serial numbers, and ID plates. Crisp at any scale, on any surface.",
    bullets: ["Logos & branding", "Serial / part numbers", "Anodized aluminum specialty"],
    img: "https://images.unsplash.com/photo-1713371398484-cc4e4f6a262a?auto=format&fit=crop&w=1600&q=80",
  },
  {
    icon: Wrench,
    title: "Prototyping",
    blurb:
      "From napkin sketch to working part. Quick iterations for hardware founders and product teams.",
    bullets: ["Quote in hours", "Same-week parts", "Design feedback included"],
    img: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1600&q=80",
  },
  {
    icon: Boxes,
    title: "Bulk & Commercial",
    blurb:
      "Production-grade runs for commercial products. Consistent quality, predictable lead times, real volume.",
    bullets: ["100 → 10,000+ units", "Repeat order discounts", "Dedicated project lead"],
    img: "https://images.unsplash.com/photo-1513828583688-c52646db42da?auto=format&fit=crop&w=1600&q=80",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      className="border-b border-zinc-800 bg-zinc-950 py-20 sm:py-28"
      data-testid="services-section"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-12 flex flex-col items-start justify-between gap-4 sm:mb-16 sm:flex-row sm:items-end">
          <div>
            <p className="font-mono-spec mb-3 text-orange-500">// 01 — What We Do</p>
            <h2 className="font-display text-5xl text-white sm:text-6xl lg:text-7xl">
              Four Services.
              <br />
              <span className="text-zinc-500">Zero Fluff.</span>
            </h2>
          </div>
          <p className="max-w-md text-zinc-400">
            Pick the one that fits your job. Not sure? Book a 10-minute call and
            we&apos;ll point you in the right direction.
          </p>
        </div>

        <div className="grid border-l border-t border-zinc-800 lg:grid-cols-2">
          {services.map(({ icon: Icon, title, blurb, bullets, img }, i) => (
            <article
              key={title}
              className="group relative border-b border-r border-zinc-800 bg-zinc-950 transition-colors duration-150 hover:bg-zinc-900/50"
              data-testid={`service-card-${i}`}
            >
              <div className="aspect-[16/9] w-full overflow-hidden border-b border-zinc-800">
                <img
                  src={img}
                  alt={title}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-8">
                <div className="mb-5 flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="flex h-10 w-10 items-center justify-center border border-orange-600 bg-orange-600">
                      <Icon className="h-5 w-5 text-white" strokeWidth={2.5} />
                    </div>
                    <p className="font-mono-spec text-zinc-500">
                      0{i + 1}
                    </p>
                  </div>
                  <button
                    onClick={scrollToBook}
                    className="flex items-center gap-1 font-mono-spec text-zinc-400 transition-colors duration-100 hover:text-orange-500"
                    data-testid={`service-quote-link-${i}`}
                  >
                    Get a quote <ArrowUpRight className="h-4 w-4" />
                  </button>
                </div>
                <h3 className="font-display text-3xl text-white sm:text-4xl">
                  {title}
                </h3>
                <p className="mt-3 text-zinc-400">{blurb}</p>
                <ul className="mt-5 space-y-2">
                  {bullets.map((b) => (
                    <li
                      key={b}
                      className="flex items-start gap-3 text-sm text-zinc-300"
                    >
                      <span className="mt-2 h-1 w-3 flex-shrink-0 bg-orange-500" />
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
